// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Ul-z","badgeLink":"Vl-z","category":"Wl-z"};